//tslint:disable
import React, { useEffect } from 'react';

import SchemaBase from '../SchemaBase/SchemaBase';
import { useAxios } from '../../../AxiosHandler';
import Slider from "react-slick";

import { useTranslate } from 'react-polyglot';
import { Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import styles from './DynSchema.module.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function DynSchema(props: DynSchemaProps) {
    const t = useTranslate();
    const params = useParams();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loading, setLoading] = React.useState(false);
    const [schema, setSchema] = React.useState<any>({});

    function getSchema() {
        setLoading(true);
        axios.single({
            method: 'get',
            url: "/api/dynschema/" + (props.breedid || params.breedid) + "/" + (props.dynschemaid || params.dynschemaid),
            responseType: 'json',
        }).then((res: any) => {
            setSchema(res.data);
        }).catch((err: any) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    function drawQuestion(question: any, index: number) {
        let customtrait = question.CUSTOMTRAIT_ID != null;
        let datatype = customtrait ? question.CUSTOMTRAIT_DATATYPE : question.TRAIT_DATATYPE;
        let traitOptions = customtrait ? question.CUSTOMTRAIT_OPTIONS : question.TRAIT_OPTIONS;

        if (traitOptions != null && traitOptions != undefined) {
            traitOptions = traitOptions?.split(",");
        } else {
            traitOptions = undefined;
        }

        const renderDescription = (desc: any) => {
            if (desc == null) return null;
            if (typeof desc === "string" && desc.includes("http")) {
                return <a href={desc} target="_blank" rel="noreferrer">{desc}</a>;
            }
            return desc;
        };

        switch (datatype) {
            case null:
                return <div className="divider" key={question.ID}>
                    <hr/>
                    {question.TEXT && <h2>{question.TEXT}</h2>}
                    {question.DESCRIPTION && <p>{renderDescription(question.DESCRIPTION)}</p>}
                </div>;
            case "string":
                return <div className="inputfield" key={question.ID}>
                    <Form.Label htmlFor={"input" + question.ID}>{question.TEXT}</Form.Label>
                    <Form.Control
                        id={"input" + question.ID}
                        aria-describedby={question.ID + "HelpBlock"}
                        value={schema.questions[index].answer ?? ''}
                        onChange={(e) => {
                            const temp = JSON.parse(JSON.stringify(schema));
                            temp.questions[index].answer = e.target.value;
                            setSchema(temp);
                        }}
                    />
                    {question.DESCRIPTION != null ?
                        <Form.Text id={question.ID + "HelpBlock"} muted>
                            {renderDescription(question.DESCRIPTION)}
                        </Form.Text>
                    : null }
                    {renderChips(question, index)}
                </div>;
            case "dropdown":
                return <div className="inputfield" key={question.ID}>
                    <Form.Label htmlFor={"input" + question.ID}>{question.TEXT}</Form.Label>
                    <Form.Select
                        id={"input" + question.ID}
                        aria-describedby={question.ID + "HelpBlock"}
                        value={schema.questions[index].answer}
                        onChange={(e) => {
                            let temp = schema;
                            temp.questions[index].answer = e.target.value;
                            setSchema(temp);
                        }}
                    >
                        <option>{t('dynschema.field.dropdown.select')}</option>
                        {traitOptions.map((option: any) => {
                            return <option key={option} value={option}>{option}</option>;
                        })}
                    </Form.Select>
                    {question.DESCRIPTION != null ?
                        <Form.Text id={question.ID + "HelpBlock"} muted>
                            {renderDescription(question.DESCRIPTION)}
                        </Form.Text>
                    : null }
                </div>;
            case "number":
                return <div className="inputfield" key={question.ID}>
                    <Form.Label htmlFor={"input" + question.ID}>{question.TEXT}</Form.Label>
                    <Form.Control
                        id={"input" + question.ID}
                        aria-describedby={question.ID + "HelpBlock"}
                        value={schema.questions[index].answer}
                        type="number"
                        onChange={(e) => {
                            let temp = schema;
                            temp.questions[index].answer = e.target.value;
                            setSchema(temp);
                        }}
                    />
                    {question.DESCRIPTION != null ?
                        <Form.Text id={question.ID + "HelpBlock"} muted>
                            {renderDescription(question.DESCRIPTION)}
                        </Form.Text>
                    : null }
                </div>;
            case "imagecompare":
                const images = JSON.parse(question.CUSTOMTRAIT_CUSTOMDATA).images;
                return (
                    <div className="inputfield" key={question.ID}>
                        <Form.Label htmlFor={"input" + question.ID}>{question.TEXT}</Form.Label>
                        <br/>
                        {question.DESCRIPTION != null ? (
                            <Form.Text id={question.ID + "HelpBlock"} muted>
                                {question.DESCRIPTION}
                            </Form.Text>
                        ) : null}
                        <Slider
                            className={styles.slider}
                            dots={true}
                            infinite={true}
                            speed={500}
                            slidesToShow={1}
                            slidesToScroll={1}
                        >
                            {images.map((image: any, imageindex: number) => {
                                return (
                                    <div
                                        key={imageindex}
                                        className={styles.imagecontainer}
                                    >
                                        <img
                                            src={image}
                                            alt={question.TEXT + " " + imageindex}
                                            className={styles.image}
                                        />
                                        <button
                                            className={"btn " + (schema.questions[index].answer == imageindex + 1 ? "btn-success " : "btn-primary ") + styles.selectbutton}
                                            onClick={() => {
                                                let temp = schema;
                                                temp.questions[index].answer = imageindex + 1;
                                                setSchema(JSON.parse(JSON.stringify(temp)));
                                            }}
                                        >
                                            {schema.questions[index].answer == imageindex + 1 ? t("dynschema.field.imagecompare.selectbutton_selected") : t("dynschema.field.imagecompare.selectbutton")}
                                        </button>
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                );
            
        }
    }
    
    function renderChips(question: any, index: number) {
        if (!props.chipData || props.chipData.length === 0) return null;
        const text = (question.TEXT || '').toLowerCase();
        const relevant = props.chipData.filter((chip: any) =>
            chip.value != null && chip.value !== '' &&
            chip.matchKeywords.every((kw: string) => text.includes(kw.toLowerCase()))
        );
        if (relevant.length === 0) return null;
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                {relevant.length > 0 && <span>{t("dynschema.field.chips.relevant")}</span>}
                {relevant.map((chip: any, i: number) => (
                    <button
                        key={i}
                        type="button"
                        style={{
                            padding: '2px 10px',
                            borderRadius: '12px',
                            border: '1px solid #aaa',
                            background: '#f0f0f0',
                            cursor: 'pointer',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                        }}
                        onClick={() => {
                            const temp = JSON.parse(JSON.stringify(schema));
                            temp.questions[index].answer = chip.value;
                            setSchema(temp);
                        }}
                        title={`Fyll inn: ${chip.value}`}
                    >
                        {chip.label}: <strong>{chip.value}</strong>
                    </button>
                ))}
            </div>
        );
    }

    // Draw input elements based on schema questions
    function drawSchema(schema: any) {
        let elements: any[] = [];
        if (schema.questions) {
            for (let i = 0; i < schema.questions.length; i++) {
                elements.push(
                    drawQuestion(schema.questions[i], i)
                );
            }
        }
        return elements;
    }

    useEffect(() => {
        getSchema();
    }, []);
    
    return (
        <SchemaBase
            title={loading ? t("dynschema.loading.title") : (props.title || schema?.TITLE)}
            disableSubmit={loading || schema == undefined || props.disableSubmit}
            description={loading ? "" : (props.description || schema?.DESCRIPTION)}
            schema={schema}
            schemaKey={"dynschema"}
            breedId={props.breedid || params.breedid}
            onSchemaSent={props.onSchemaSent}
        >
            {schema != undefined ? drawSchema(schema) : null}
            { schema == undefined && !loading ?
                <h2>{t("dynschema.loading.error")}</h2>
            : null}
        </SchemaBase>
    );
}

class DynSchemaProps {
    breedid?: string;
    dynschemaid?: string;
    disableSubmit?: boolean;
    title?: string;
    description?: string;
    onSchemaSent?: () => void;
    chipData?: { label: string; value: string | null | undefined; matchKeywords: string[] }[];
}

export default DynSchema;